import { render } from "./Footer.vue?vue&type=template&id=22518280&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=22518280&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22518280"]])

export default __exports__